// ISOStandardDetails.jsx

import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';


const ISOStandardDetails = () => {
  const { id } = useParams();
  const [standard, setStandard] = useState(null);

  useEffect(() => {
    fetchStandard();
  }, []);

  const fetchStandard = async () => {
    try {
      const response = await axios.get(`/api/isocertifications/${id}`);
      setStandard(response.data);
    } catch (error) {
      console.error('Error fetching ISO standard details:', error);
    }
  };

  if (!standard) {
    return <div>Loading...</div>;
  }

  return (
    <div className="standard-detail">
      <h2>{standard.standardName}</h2>
      <h3>{standard.standardTitle}</h3>
      <p><strong>Category:</strong> {standard.standardCategory}</p>
      <p><strong>Details:</strong> {standard.standardDetails}</p>
      {standard.processNote && <p><strong>Process Note:</strong> {standard.processNote}</p>}
    </div>
  );
};

export default ISOStandardDetails;
